import { EditorTemplatesControlpanelView } from '@plone-collective/volto-editortemplates/components/Controlpanel/index';
import { blockTemplatesReducer } from '@plone-collective/volto-editortemplates/reducers/blocks-reducers';
import { Edit } from '@plone-collective/volto-editortemplates/components/Blocks/TemplateSelectorBlock/Edit';
import { View } from '@plone-collective/volto-editortemplates/components/Blocks/TemplateSelectorBlock/View';
import { TemplateSelectorBlockSchema } from '@plone-collective/volto-editortemplates/components/Blocks/TemplateSelectorBlock/schema';
import BlockTemplateIcon from '@plone-collective/volto-editortemplates/components/icons/block-template-icon.svg';
import blockTemplateIconSVG from '@plone-collective/volto-editortemplates/components/icons/block-template-icon.svg';

const applyConfig = (config) => {
  config.settings['volto-editor-templates'] = {
    ...config.settings['volto-editor-templates'],
    excludeBlocksFromTemplates: ['blockTemplateSelector'],
  };
  config.settings.controlPanelsIcons = {
    ...config.settings.controlPanelsIcons,
    'volto-editor-templates-settings': blockTemplateIconSVG,
  };
  config.blocks.blocksConfig = {
    ...config.blocks.blocksConfig,
    blockTemplateSelector: {
      id: 'blockTemplateSelector',
      title: 'Template block',
      icon: BlockTemplateIcon,
      group: 'common',
      edit: Edit,
      view: View,
      restricted: false,
      mostUsed: true,
      sidebarTab: 1,
      blockSchema: TemplateSelectorBlockSchema,
    },
  };

  config.addonRoutes = [
    ...config.addonRoutes,
    {
      path: '/controlpanel/volto-editor-templates-settings',
      component: EditorTemplatesControlpanelView,
    },
  ];

  config.addonReducers = {
    ...config.addonReducers,
    blocksTemplates: blockTemplatesReducer,
  };
  return config;
};

export default applyConfig;
